
import { Options, Vue }    from 'vue-class-component';

@Options({

})

export default class StartPage extends Vue {

}
